import * as ng from 'angular';
import { DropboxService } from '../../../services/dropbox.service';

class DropboxAuthController implements ng.IController {

    static $inject: string[] = [
        '$rootScope',
        '$location',
        'DropboxService',
        'store'
    ];

    constructor(
        private $rootScope: any, // ng.IRootScopeService,
        private $location: ng.ILocationService,
        private DropboxService: DropboxService,
        private store: ng.a0.storage.IStoreService
    ) {
        let code = $location.search().code;

        let fireAuthorizationEnd = (user) => {
            window.opener.parentScope.user = user;
            window.opener.parentScope.dropboxAuthorizationDone = true;
            window.opener.parentScope.$apply();

        };

        let authorize = () => {
            DropboxService.authorize(code)
                .then((response) => {
                    store.set('user', response);
                    fireAuthorizationEnd(response);
                })
                .catch((error) => {
                    $rootScope.alert('error', error.data);
                });
        };
        if (code !== undefined && code !== '') {
            authorize();
        } else {
            if (window.opener) {
                window.opener.parentScope.authorizationError = true;
                window.opener.parentScope.$apply();
            }
        }
    }
}

export const DropboxAuthComponent: ng.IComponentOptions = {
    template: require('./dropbox-auth.html'),
    controller: DropboxAuthController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/dropbox-auth/dropbox-auth.ts